module.exports = __webpack_public_path__ + "img/Patient_Text.881deba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patient_Text.png
// module id = 584
// module chunks = 5